module.exports = __webpack_public_path__ + "img/p1-c3-p1.471710e0.jpg";